import { DeviceIconDto } from './../icons/AvailableIconDto';
import { DeviceModel } from '../deviceModel/DeviceModel';
import { CustomerInfoResponse } from '../customerInfo/CustomerInfoResponse';
import { WarrantyDto } from './Warranty';
import { DeviceRmaRecordDto } from './DeviceRmaRecord';

export default interface Device {
  active: boolean;
  config: null; // TODO: implement
  configuration: string | null;
  customerInfo: CustomerInfoResponse | null;
  description: string | null;
  device: null;
  hwVersion: string;
  meterInfo: null;
  model: DeviceModel;
  deviceIcon: string | null; // old implementation
  deviceIconDto: DeviceIconDto; // new
  name: string;
  number: string;
  language: DeviceLanguage | null;
  replacementNumber: string | null;
  replacedBy: string | null;
  parent: boolean;
  parentNumber: string | null;
  swVersion: string;
  nomenclature: string | null;
  ownerCompanyId: number | null;
  createdBy: string | null;
  createdOn: string | null;
  manufacturingDate: string | null;
  warrantyPeriodMonths: number | null;
  extendedHardwareSupport: boolean;
  warranty: WarrantyDto | null;
  installDate: string | null;
  installWarrantyPeriodMonths: number | null;
  rmaHistory: DeviceRmaRecordDto[];
  timezone: string | null;
}

export interface DeviceCreateUpdateBody {
  number: string;
  replacementNumber: string | null;
  description: string | null;
  hwVersion: string;
  model: DeviceModel;
  deviceIcon: string | null; // old implementation
  iconId: number;
  name: string;
  swVersion: string;
  nomenclature: string | null;
  ownerCompanyId: number | null;
  manufacturingDate: string | null;
  warrantyPeriodMonths: number | null;
  extendedHardwareSupport: boolean;
  installDate: string | null;
  installWarrantyPeriodMonths: number | null;
  language: DeviceLanguage | null;
  rmaHistory?: DeviceRmaRecordDto[];
  timezone: string | null;
}

export enum DeviceLanguage {
  EN = 'EN',
  BG = 'BG',
  DE = 'DE',
  ES = 'ES',
  FR = 'FR',
  GR = 'GR',
  PT_BR = 'PT_BR',
  RU = 'RU',
}
